<template>
  <div class="zcbody">
    <div class="protocol-accept1">
      <span><b>关联企业</b>
        (如果贵公司有其他关联公司已经在认养一头牛供应商开展采购业务，请填写关联信息)</span>
      <el-button size="mini" type="success" class="pull-right" @click="addtable">新增</el-button>
    </div>
    <el-table :data="tableasso" border style="width: 100%" max-height="420" :header-cell-style="{ background: '#eef1f6', textAlign: 'center' }" :cell-style="{ textAlign: 'center' }">
      <el-table-column type="index" label="序号" width="50"></el-table-column>
      <el-table-column prop="cfrimname" label="企业名称"></el-table-column>
      <el-table-column prop="cfirmtaxnum" label="税号"></el-table-column>
      <el-table-column prop="cfirmremaks" label="备注"></el-table-column>

      <el-table-column prop="name" label="操作" width="160">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="regit(scope.row, scope.$index)" style="marign-right: 5px">修改</el-button>
          <el-button size="mini" type="danger" @click="del(scope.row, scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="新增关联企业" :visible.sync="dialogFormVisible" customClass="way assoform" :append-to-body="true">
      <el-form ref="assoruleForm" :rules="assorules" :model="assoform" label-width="85px" class="form01">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="企业名称:" prop="cfrimname">
              <el-input v-model="assoform.cfrimname" placeholder="请输入企业名称"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="信用代码:" prop="cfirmtaxnum">
              <el-input v-model="assoform.cfirmtaxnum" placeholder="请输入信用代码"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="备注:" prop="cfirmremaks" label-width="100%" style="margin-bottom:0;" class="itemcenter"></el-form-item>
            <el-form-item prop="cfirmremaks" label-width="0">
              <el-input type="textarea" v-model="assoform.cfirmremaks" placeholder="请输入备注" rows="4" style="width:100%"></el-input>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closesad('assoruleForm')">取 消</el-button>
        <el-button type="success" @click="confirm('assoruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    assotbale: { Type: Object },
  },
  data() {
    return {
      state: "-1",
      dialogFormVisible: false,
      tableasso: this.assotbale,
      assoform: {
        cfrimname: "",
        cfirmtaxnum: "",
        cfirmremaks: "",
      },
      assorules: {
        cfrimname: [
          { required: true, message: "请输入企业名称", trigger: "blur" },
        ],
        cfirmtaxnum: [
          { required: true, message: "请输入税号", trigger: "blur" },
        ],
        cfirmremaks: [
          { required: true, message: "请输入备注", trigger: "blur" },
        ],
      },
    };
  },
  created() {},
  methods: {
    addtable() {
      this.state = "-1";
      this.dialogFormVisible = true;
      this.assoform = {
        cfrimname: "",
        cfirmtaxnum: "",
        cfirmremaks: "",
      };
    },
    closesad(assoruleForm) {
      this.$refs[assoruleForm].resetFields();
      this.dialogFormVisible = false;
    },
    confirm(assoruleForm) {
      this.$refs[assoruleForm].validate((valid) => {
        if (valid) {
          console.log(this.state);
          if (this.state == "-1") {
            this.tableasso.push(this.assoform);
          } else {
            this.tableasso.splice(this.state, 1);
            console.log(this.tableSDA);
            setTimeout(() => {
              this.tableasso.push(this.assoform);
              this.$emit("assolist", this.tableasso);
            }, 30);
          }
          this.dialogFormVisible = false;

          console.log(this.tableasso);
        } else {
          return false;
        }
      });
    },
    regit(row, i) {
      this.state = i;
      // this.assoform = row;
      this.assoform = JSON.parse(JSON.stringify(row));
      this.dialogFormVisible = true;
    },
    del(row, i) {
      this.tableasso.splice(i, 1);
    },
  },
};
</script>
<style scoped>
@import url(../../../assets/css/reg.css);
</style>